module.exports = __webpack_public_path__ + "static/img/new-13.2768ffc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-13.png
// module id = OIsn
// module chunks = 0